import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
  selector: 'app-stepbystep',
  standalone: false,
  templateUrl: './stepbystep.component.html',
  styleUrls: ['./stepbystep.component.scss']
})
export class StepbystepComponent {
  constructor(private userInfoService:UserInfoService,public component: CmsComponentData<CmsBannerComponent>, protected config: OccConfig,private cdr: ChangeDetectorRef ) { }
  uptkdetaileddata: Observable<any> = this.component.data$;
  getImage(media: any): string {
    return this.config.backend?.occ?.baseUrl + media.url;
  }
  getpdf(pdf: any): string {
    return this.config.backend?.occ?.baseUrl + pdf?.url + "&attachment=true";
  }
  screenvalue:number=999
  ngOnInit() {
   this.userInfoService.getuptake().subscribe((value:any)=>{
   this.screenvalue=value
   this.cdr.detectChanges()
   });
  }
}
